import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { GET_URL_BY_ID } from '@utils/api/endpoints.ts';

export interface UserBo {
  email?: string;
  first_name?: string;
  id?: number;
  last_name?: string;
  newsletter_consent?: boolean;
  roles?: string[];
}

export interface CustomerBoUsageResponse {
  count: number;
  total_result: number;
  result: UserBo;
}

export const useGetCustomerIamUser = (
  customerId: number,
  userId: number,
  limit = 10,
  offset = 0
) => {
  const fetchCustomerUsage = async () => {
    const response = await Axios.get<CustomerBoUsageResponse>(
      GET_URL_BY_ID(
        customerId.toString(),
        userId.toString(),
        offset.toString(),
        limit.toString()
      ).customerUserIam,
      {
        params: { limit, offset }
      }
    );
    return response.data;
  };

  return useQuery<CustomerBoUsageResponse, AxiosError<BaseError>>(
    ['customerUser', customerId, userId, limit, offset],
    fetchCustomerUsage,
    {
      useErrorBoundary: false
    }
  );
};
